import React from "react";
import PropTypes from "prop-types";
import ReactTooltip from "react-tooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import SocialLinks from "./SocialLinks";
import AvgResponseTime from "./AvgResponseTime";
import Description from "./Description";
import CustomTerms from "./CustomTerms";
import EmployeesAndHQ from "./EmployeesAndHQ";
import descriptionType from "./types/descriptionType";
import noLogo from "./img/no-logo.png";
import portalLogo from "../shared/general/img/hhPortalLogo.png";
import premiumLogo from "./img/premiumLogo.png";
import {
  EmployerDescriptionWrapper,
  LogosWrapper,
  Logo,
  CompanyLogo,
  PremiumLogoWrapper,
  PortalLogoWrapper,
  PortalLogo,
  PremiumLogo,
  WebsiteWrapper,
  WebsiteLink,
} from "./styles/employer-description-styles";

const EmployerDescription = ({
  description,
  showAvgResponseTime,
  isPortalEmployer,
  isPremiumEmployer,
  isRecruiter,
}) => {
  const {
    about,
    customTerms,
    customTermsUrl,
    city,
    postalAddress,
    companyName,
    employeesCount,
    logo,
    website,
    socialLinks,
    glassDoorLink,
    avgResponseTime,
  } = description;

  const portalEmployerTooltipText =
    "Portal clients use the marketplace as an extension of their direct PSL, and manage all their third-party permanent recruitment through Hiring Hub 👍";

  const premiumEmployerTooltipText =
    "Highly engaged: this client is using Hiring Hub’s paid, Premium Account Service and therefore committed to filling this role on the platform.";

  return (
    <EmployerDescriptionWrapper>
      <LogosWrapper>
        <Logo>
          <CompanyLogo src={logo || noLogo} alt={companyName} />
        </Logo>
        {isPremiumEmployer && (
          <PremiumLogoWrapper id="premium-logo">
            <ReactTooltip
              html
              place="left"
              type="dark"
              effect="solid"
              aria-haspopup="true"
              id="paying-employer-tooltip"
            />
            <PremiumLogo src={premiumLogo} alt="Hiring Hub Premium" />
            {isRecruiter && (
              <FontAwesomeIcon
                icon={faInfoCircle}
                id="premium-employer-tooltip"
                data-for="paying-employer-tooltip"
                data-tip={premiumEmployerTooltipText}
              />
            )}
          </PremiumLogoWrapper>
        )}
        {isPortalEmployer && (
          <PortalLogoWrapper id="portal-logo">
            <ReactTooltip
              html
              place="left"
              type="dark"
              effect="solid"
              aria-haspopup="true"
              id="paying-employer-tooltip"
            />
            <PortalLogo src={portalLogo} alt="Hiring Hub Portal" />
            {isRecruiter && (
              <FontAwesomeIcon
                icon={faInfoCircle}
                id="portal-employer-tooltip"
                data-for="paying-employer-tooltip"
                data-tip={portalEmployerTooltipText}
              />
            )}
          </PortalLogoWrapper>
        )}
      </LogosWrapper>
      <WebsiteWrapper>
        <WebsiteLink href={website} target="_blank" title="Website">
          {website && website.replace(/(^\w+:|^)\/\//, "")}
        </WebsiteLink>
        <SocialLinks socialLinks={socialLinks} glassDoorLink={glassDoorLink} />
      </WebsiteWrapper>
      <EmployeesAndHQ
        employeesCount={employeesCount}
        postalAddress={postalAddress}
        city={city}
      />
      {showAvgResponseTime && (
        <AvgResponseTime avgResponseTime={avgResponseTime} />
      )}
      <Description about={about} />
      <CustomTerms customTerms={customTerms} customTermsUrl={customTermsUrl} />
    </EmployerDescriptionWrapper>
  );
};

EmployerDescription.propTypes = {
  description: descriptionType.isRequired,
  showAvgResponseTime: PropTypes.bool,
  isPortalEmployer: PropTypes.bool,
  isPremiumEmployer: PropTypes.bool,
  isRecruiter: PropTypes.bool.isRequired,
};

EmployerDescription.defaultProps = {
  showAvgResponseTime: null,
  isPortalEmployer: null,
  isPremiumEmployer: null,
};

export default EmployerDescription;
